export default __webpack_public_path__ + "static/media/image_triple_100.b2c052b0.svg";